<template>
    <div class="container">
        <div v-if="filters.main">
            <div class="filters-container main-filters">
                <CustomButton
                    v-for="option in filters.main.filter_items.data"
                    v-model="filters.main.value"
                    class="filter-box"
                    :key="option.id"
                    :options="option"
                    :value="option.id"
                    :current="filters.main.value"
                    @input="performSearch($event)"
                />

                <ResetButton
                    class="filter-box"
                    @click="resetFilters"
                />
            </div>
        </div>

        <div v-for="button in filters.buttons">
            <h3>{{button.name}}</h3>
            <div class="filters-container buttons-filters">
                <CustomButton
                    v-for="option in button.filter_items.data"
                    v-model="button.value"
                    class="filter-box"
                    :key="option.id"
                    :options="option"
                    :value="option.id"
                    :current="button.value"
                    @input="performSearch($event)"
                />
            </div>
        </div>
        
        <div class="filters-container selects-filters last-container">
            <CustomSelect
                v-for="select in filters.selects"
                v-model="select.value"
                class="filter-box"
                :key="select.id"
                :options="select.filter_items.data"
                :defaultOption="{ name: select.title, id: 0 }"
                :hideSelected="false"
                @input="selectSearch(select, $event)"
            />
        </div>
    </div>
</template>

<script>
import resources from "../../resources";
import EventBus from "../../eventbus";
import CustomSelect from "./CustomSelect";
import CustomButton from "./CustomButton";
import SearchBox from "./SearchBox";
import ResetButton from "./ResetButton";

export default {
    components: {
        ResetButton,
        CustomSelect,
        CustomButton,
        SearchBox,
    },
    data(){
        return {
            searchForm: {
                query: ''
            },
            filters: {
                text: '',
                main: null,
                selects: null,
                buttons: null,
            }
        }
    },
    mounted(){
        this.loadFilters()
        EventBus.$on('languageChanged', () => this.loadFilters(true));
    },
    methods: {
        loadFilters(langChanged = false){
            resources.filters.index({})
                .then((response) => {

                    const main = response.data.data.find(filter => filter.tag === 'main');
                    const selects = response.data.data.filter(filter => filter.tag === 'select');
                    const buttons = response.data.data.filter(filter => filter.tag === 'radio');

                    if (langChanged) {
                        this.filters.selects.forEach((select, index) => {
                            const newSelect = selects.find((item) => item.id === select.id);

                            select.name = newSelect.name;
                            select.filter_items = newSelect.filter_items;

                            const lastItem = newSelect.filter_items.data.find(item => item.id === select.value);
                            select.title = (lastItem) ? lastItem.name : newSelect.name;
                        });

                        this.filters.buttons.forEach((button, index) => {
                            const newButton = buttons.find((item) => item.id === button.id);

                            button.name = newButton.name;
                            button.filter_items.data.forEach((option, index) => {
                                const lastItem = newButton.filter_items.data.find(item => item.id === option.id);
                                option.name = lastItem.name;
                            });
                        });

                        this.filters.main.filter_items.data.forEach((option, index) => {
                            const newOption = main.filter_items.data.find((item) => item.id === option.id);
                            main.name = newOption.name;
                        });
                    } else {
                        this.filters.selects = selects;
                        this.filters.buttons = buttons;
                        this.filters.main = main;

                        for (let i = 0; i < this.filters.selects.length; i++) {
                            this.filters.selects[i].title = this.filters.selects[i].name;
                        }
                    }

                }).catch(error => {
                    console.log(error)
                });
        },
        selectSearch(filter, id) {
            if (id === 0) {
                filter.title = filter.name;
                filter.value = 0;
            } else {
                const newNode = filter.filter_items.data.find(filter_time => filter_time.id === id);
                filter.title = newNode.name;
            }

            let request = {}
            this.params.forEach(param => {
                request[param.key] = param.value;
            });
  
            request.text = this.filters.text
            this.$emit("filter", request);
        },
        performSearch() {
            let request = {}
            this.params.forEach(param => {
                request[param.key] = param.value;
            });
  
            request.text = this.filters.text
            this.$emit("filter", request);
        },
        resetFilters() {
            this.params.forEach(param => {
                param.value = 0;
            });
            EventBus.$emit('resetFilters');
            this.performSearch();
        }
    },
    computed: {
        params() {
            return [
                ...[this.filters.main],
                ...this.filters.buttons,
                ...this.filters.selects
            ];
        },
    },
    watch: {
        'filters.text'(value){
            if(value.length >= 3 || value.length === 0) {
                this.resetFilters();
                this.performSearch(value);
            }
        },
        $route: function(){
            this.resetFilters();
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';
@import '../../styles/classes';

.container{
    padding: 30px 10px 30px 20px;
    border-top: 1px solid var(--pallete_main_color);
    border-bottom: 1px solid var(--pallete_main_color);

    h3{
        color: var(--pallete_clear_text_color);
        text-transform: uppercase;
    }

    .filters-container{
        display: flex;
        justify-content: space-evenly;

        &.last-container{
            margin-top: 50px;
        }

        .filter-box{
            width: 22%;
        }

        @media(max-width: 768px){
            &.main-filters{
                flex-wrap: wrap;

                //// esto solo si filter-search-box está presente
                //.filter-box{
                //    width: 30%;
                //
                //    &.filter-search-box{
                //        width: 100%;
                //        margin-bottom: 20px;
                //    }
                //}
            }

            &.buttons-filters{}

            &.selects-filters{
                flex-wrap: wrap;

                .filter-box{
                    width: 46%;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
</style>
